import { useState, useEffect } from 'react';

export function useDSTabs({ model, defaultIdx, callback }) {
  const [activeTabIdx, setActiveTabIdx] = useState(defaultIdx);
  const [activeTab, setActiveTab] = useState(model[defaultIdx]);

  const onTabChange = (event, newValue) => {
    setActiveTabIdx(newValue);
  };

  useEffect(() => {
    const newTabItem = model[activeTabIdx];
    setActiveTab(newTabItem);
    callback(newTabItem);
  }, [activeTabIdx]);

  return {
    activeTabIdx,
    activeTab,
    onTabChange,
  };
}
